import UserListTable from './lib/table';
import { useTypedSelector } from 'common/hooks/useTypedSelector';
import AppLoading from 'components/appLoading';
import PageTitle from 'components/pageTitle';

import * as S from './styles';

export default function UsersPage() {
  const { userList } = useTypedSelector((state: any) => state.Users);
  const { departments } = useTypedSelector((state) => state.Departments);

  return (
    <S.Container>
      {/* PageTitle renders nothing — it declares the topbar's heading. The
          screen has no actions of its own, so the head row that used to wrap
          it is gone rather than left empty. */}
      <PageTitle title="User List" />
      <UserListTable data={userList.data} departments={departments.data} loading={userList.loading} />

      <AppLoading loading={departments.loading} />
    </S.Container>
  );
}
